<template>
    <AudienceStatsSummary />
    <AudienceActions />
    <AudienceLabels />

    <section class="container-fluid content-type-37 side-by-side" v-if="showTagsOwners">
        <div class="container">
            <div class="row">
                <AudienceTags ref="tags" @update-visibility="updateVisibility" />
                <AudienceOwners ref="owners" @update-visibility="updateVisibility" />
            </div>
        </div>
    </section>
</template>

<script>
    import AudienceStatsSummary from '@/components/account/audience/AudienceStatsSummary';
    import AudienceLabels from '@/components/account/audience/AudienceLabels';
    import AudienceTags from '@/components/account/audience/AudienceTags';
    import AudienceOwners from '@/components/account/audience/AudienceOwners';
    import AudienceActions from '@/components/account/audience/AudienceActions';

    export default {
        name: "AudienceDetails",
        components: {
            AudienceStatsSummary,
            AudienceLabels,
            AudienceTags,
            AudienceOwners,
            AudienceActions
        },
        data() {
            return {
                showTagsOwners: true
            }
        },
        methods: {
            updateVisibility() {
                const tags = !this.$refs.tags || this.$refs.tags.hide;
                const owners = !this.$refs.owners || this.$refs.owners.hide;
                const hide = tags && owners;
                this.showTagsOwners = !hide;
            }
        }
    }
</script>